<template>
    <div class="revenue-daily">
        <div class="revenue-daily-header">
            <el-select
                @change="fetchAll"
                v-model="form.storeId"
                :placeholder="$t('Common.all_store2')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <div class="daily-header-right">{{ $t('Week.refresh_time2') }}：{{ updateDate }}</div>
        </div>
        <div class="stats-table-cart flex items-center justify-between">
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.today_total') }}</div>
                <div class="table-cart-num">{{ summaryData.totalRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.totalRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.totalRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.totalRevenueOfMonth }}</div>
                </div>
            </div>
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.member') }}</div>
                <div class="table-cart-num">{{ summaryData.mshpRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.mshpRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.mshpRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.mshpRevenueOfMonth }}</div>
                </div>
            </div>
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.personal') }}</div>
                <div class="table-cart-num">{{ summaryData.privCoachRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.privCoachRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.privCoachRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.privCoachRevenueOfMonth }}</div>
                </div>
            </div>
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.locker') }}</div>
                <div class="table-cart-num">{{ summaryData.lockerRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.lockerRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.lockerRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.lockerRevenueOfMonth }}</div>
                </div>
            </div>
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.card') }}</div>
                <div class="table-cart-num">{{ summaryData.CzCardRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.CzCardRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.CzCardRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.CzCardRevenueOfMonth }}</div>
                </div>
            </div>
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.charge') }}</div>
                <div class="table-cart-num">{{ summaryData.prepayRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.prepayRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.prepayRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.prepayRevenueOfMonth }}</div>
                </div>
            </div>
            <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.charge2') }}</div>
                <div class="table-cart-num">{{ summaryData.depositRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.depositRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.depositRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.depositRevenueOfMonth }}</div>
                </div>
            </div>
             <div class="table-cart-items">
                <div class="table-cart-title">{{ $t('Stats.Revenue.stop') }}</div>
                <div class="table-cart-num">{{ summaryData.otherRevenueOfToday }}</div>
                <div class="table-cart-small">
                    <div>{{ $t('Stats.Time.yesterday') }} {{ summaryData.otherRevenueOfYesterday }}</div>
                    <div>{{ $t('Stats.Time.this_week') }} {{ summaryData.otherRevenueOfWeek }}</div>
                    <div>{{ $t('Stats.Time.this_month') }} {{ summaryData.otherRevenueOfMonth }}</div>
                </div>
            </div>
        </div>
        <div class="revenue-daily-chart">
            <el-select @change="checkDay" v-model="range">
                <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.label"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-date-picker
                @change="fetchCharData"
                v-model="form.charDate"
                type="daterange"
                :range-separator="$t('Reception.Third.zhi')"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Common.start_time')"
                :end-placeholder="$t('Common.end_time')">
            </el-date-picker>
            <div class="daily-chart-content flex items-cneter">
                <div class="daily-chart-left">
                    <el-radio-group v-model="tabPosition" @change="getChart">
                        <el-radio-button label="dailyAdd">{{ $t('Stats.Revenue.day_up') }}</el-radio-button>
                        <el-radio-button label="dailyAll">{{ $t('Stats.Revenue.total') }}</el-radio-button>
                    </el-radio-group>
                    <div v-if="tabPosition === 'dailyAdd'" id="daily-add-number"></div>
                    <div v-if="tabPosition === 'dailyAll'" id="daily-all-number"></div>
                </div>
                <div class="daily-chart-right">
                    <div id="all-income-number"></div>
                </div>
            </div>
        </div>
        <div class="flow-date-btn flex">
            <el-date-picker
                v-model="form.pageDate"
                type="daterange"
                :range-separator="$t('Reception.Third.zhi')"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('Common.start_time')"
                :end-placeholder="$t('Common.end_time')">
            </el-date-picker>
            <el-button
                type="primary"
                class="el-button-t"
                @click="changeType(1)"
            > {{ $t('Stats.Search.type') }} </el-button>
            <el-button
                type="primary"
                class="el-button-t"
                @click="changeType(2)"
            > {{ $t('Stats.Search.pay_method') }} </el-button>
        </div>
        <el-table
            key="type1"
            :data="pageData"
            v-if="form.type === 1"
            style="width: 100%;"
            border>
            <el-table-column prop="date" :label="$t('Common.time')"/>
            <el-table-column prop="storeName" :label="$t('Common.store')"/>
            <el-table-column :label="$t('Stats.Revenue.member_contract')">
                <el-table-column prop="mshpRevenue" :label="$t('Stats.Revenue.income')"/>
                <el-table-column prop="mshpNetRevenue" :label="$t('Stats.Revenue.net_revenue')"/>
            </el-table-column>
            <el-table-column :label="$t('Stats.Revenue.personal_con')">
                <el-table-column prop="privCoachRevenue" :label="$t('Stats.Revenue.income')"/>
                <el-table-column prop="privCoachNetRevenue" :label="$t('Stats.Revenue.net_revenue')"/>
            </el-table-column>
            <el-table-column :label="$t('Stats.Revenue.locker_con')">
                <el-table-column prop="lockerRevenue" :label="$t('Stats.Revenue.income')"/>
                <el-table-column prop="lockerNetRevenue" :label="$t('Stats.Revenue.net_revenue')"/>
            </el-table-column>
            <el-table-column :label="$t('Stats.Revenue.card_con')">
                <el-table-column prop="czCardRevenue" :label="$t('Stats.Revenue.income')"/>
                <el-table-column prop="czCardNetRevenue" :label="$t('Stats.Revenue.net_revenue')"/>
            </el-table-column>
            <el-table-column prop="prepayRevenue" :label="$t('Stats.Revenue.total_deposit')"/>
            <el-table-column :label="$t('Stats.Revenue.total_charge')">
                <el-table-column prop="depositRevenue" :label="$t('Stats.Revenue.income')"/>
                <el-table-column prop="depositNetRevenue" :label="$t('Stats.Revenue.net_revenue')"/>
            </el-table-column>
            <el-table-column prop="otherRevenue" :label="$t('Stats.Revenue.total_stop')"/>
            <el-table-column :label="$t('Common.total')">
                <el-table-column prop="totalRevenue" :label="$t('Stats.Revenue.income')"/>
                <el-table-column prop="totalNetRevenue" :label="$t('Stats.Revenue.net_revenue')"/>
            </el-table-column>
        </el-table>
        <el-table
            key="type2"
            v-if="form.type === 2"
            :data="pageData"
            style="width: 100%;"
            border>
            <el-table-column prop="date" :label="$t('Common.time')"/>
            <el-table-column prop="storeName" :label="$t('Common.store')"/>
            <!-- <el-table-column prop="wechat" :label="$t('Common.wechat')"/> -->
            <!-- <el-table-column prop="alipay" label="支付宝"/> -->
            <el-table-column prop="wechatStore" :label="$t('Sell.Pay.wechat')"/>
            <el-table-column prop="alipayStore" :label="$t('Sell.Pay.alipay')"/>
            <el-table-column prop="bankTransfer" :label="$t('Sell.Pay.bank')"/>
            <el-table-column prop="cash" :label="$t('Sell.Pay.cash')"/>
            <el-table-column prop="card" :label="$t('Sell.Pay.swipe')"/>
            <el-table-column prop="otherWay" :label="$t('Sell.Pay.other')"/>
            <el-table-column prop="refund" :label="$t('Sell.refund2')"/>
        </el-table>
        <div class="page flex justify-end items-center">
            <el-pagination
                v-if="pageData && pageData.length"
                class="text-right"
                @current-change="fetchPage"
                :current-page.sync="form.page"
                :page-size="pagination.size"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total" />
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';
import {DatePicker, Radio, RadioButton, RadioGroup} from 'element-ui';
import timeMixin from '@/mixins/timeMixin.js';

export default {
    name: 'revenue-daily',
    components: {
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
    },
    mixins: [timeMixin],
    data() {
        return {
            tabPosition: 'dailyAdd',
            stores: [],
            form: {
                storeId: '',
                charDate: [],
                pageDate: [],
                type: 1,
            },
            pagination: {
                total: 0,
                size: 10,
            },
            summaryData: {},
            charData: {},
            pageData: [],
            updateDate: null,
            range: 30,
            options: [
                {
                    label: this.$t('Stats.Time.seven'),
                    id: 7,
                }, {
                    label: this.$t('Stats.Time.half_month'),
                    id: 15,
                }, {
                    label: this.$t('Stats.Time.a_month'),
                    id: 30,
                }, {
                    label: this.$t('Stats.Time.this_week'),
                    id: 'week',
                }, {
                    label: this.$t('Stats.Time.this_month'),
                    id: 'month',
                },
            ],
        };
    },
    created() {
        this.fetchDate();
        this.fetchStores();
        this.fetchSummary();
        this.checkDay();
        this.fetchTime();
    },
    methods: {
        fetchDate() {
            API.get('statistic/last-update-time?type=1')
            .then(res => {
                this.updateDate = res;
            });
        },
        fetchStores() {
            this.stores = [
                {
                    id: '',
                    name: this.$t('Common.all_store2'),
                },
            ];
            API.get(`store/list`).then(res => {
                res.filter(el => this.stores.push(el));
            });
        },
        fetchSummary() {
            API.get('statistic/revenue/summary', {
                params: this.form,
            }).then(res => {
                this.summaryData = res;
            });
        },
        fetchAll() {
            this.form.page = 1;
            this.tabPosition = 'dailyAdd';
            this.fetchDate();
            this.fetchSummary();
            this.checkDay();
            this.fetchTime();
        },
        async fetchCharData() {
            await API.get(`statistic/revenue/chart`, {
                params: {
                    dateFrom: this.form.charDate[0],
                    dateTo: this.form.charDate[1],
                    storeId: this.form.storeId,
                },
            }).then(res => {
                this.charData = res;
            });
            this.$nextTick(() => {
                this.getChart();
                this.initIncomeChart();
            });
        },
        checkDay() {
            let start;
            if (this.range === 'week') {
                const week = this.handleWeekly(new Date());
                start = week.startOfWeek;
            } else if (this.range === 'month') {
                start = this.startOfMonth(new Date());
            } else {
                start = this.subDays(new Date(), this.range);
            }
            const end = new Date().format('YYYY-MM-DD');
            let arr = [];
            arr[0] = this.range === 'week' ? start : start.format('YYYY-MM-DD');
            arr[1] = end;
            this.form.charDate = arr;
            this.fetchCharData();
        },
        fetchTime() {
            let start = this.startOfMonth(new Date()).format('YYYY-MM-DD');
            let end = new Date().format('YYYY-MM-DD');
            this.form.pageDate.push(start);
            this.form.pageDate.push(end);
            this.fetchPage();
        },
        fetchPage() {
            const form = Object.assign({}, this.form);
            form.dateFrom = this.form.pageDate[0];
            form.dateTo = this.form.pageDate[1];
            API.get('statistic/revenue/pages', {
                params: form,
            }).then(res => {
                this.pageData = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        changeType(type) {
            this.form.page = 1;
            this.form.type = type;
            this.fetchPage();
        },
        getChart() {
            if (this.tabPosition === 'dailyAdd') {
                this.initAddChart();
            } else if (this.tabPosition === 'dailyAll') {
                this.initAllChart();
            }
        },
        // 日新增
        initAddChart() {
            const chartL = document.getElementById('daily-add-number');
            chartL.style.height = '400px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            const option = {
                color: ['#05abef', 'rgb(252, 78, 78)'],
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: [this.$t('Stats.Revenue.revenue')],
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.charData.lineChart.map(el => el.date),
                },
                yAxis: {
                    type: 'value',
                },
                series: [
                    {
                        name: this.$t('Stats.Revenue.revenue'),
                        type: 'line',
                        stack: this.$t('Stats.Revenue.all'),
                        data: this.charData.lineChart.map(el => el.daily),
                    },

                ],
            };
            addChart.setOption(option);
        },
        // 总累计
        initAllChart() {
            const chartL = document.getElementById('daily-all-number');
            chartL.style.height = '400px';
            const allChart = echarts.init(chartL);
            allChart.clear();
            const option = {
                color: ['#05abef', 'rgb(252, 78, 78)'],
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: [this.$t('Stats.Revenue.revenue')],
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.charData.lineChart.map(el => el.date),
                },
                yAxis: {
                    type: 'value',
                },
                series: [
                    {
                        name: this.$t('Stats.Revenue.revenue'),
                        type: 'line',
                        stack: this.$t('Stats.Revenue.all'),
                        data: this.charData.lineChart.map(el => el.addUp),
                    },

                ],
            };
            allChart.setOption(option);
        },
        initIncomeChart() {
            const chartR = document.getElementById('all-income-number');
            chartR.style.height = '400px';
            const myChart = echarts.init(chartR);
            myChart.clear();
            const option = {
                color: ['#30C2AA', '#3ACBE3', '#2b99f0', '#1a68bd', '#a68ddb', '#f8be40', '#e95867'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                legend: {
                    orient: 'vertical',
                    x: 'right',
                    data: [
                        this.$t('Stats.Card.member'),
                        this.$t('Stats.Card.personal'),
                        this.$t('Stats.Card.locker'),
                        this.$t('Stats.Card.value_card'),
                        this.$t('Sell.title5'),
                        this.$t('Stats.Card.charge'),
                        this.$t('Stats.Revenue.total_stop'),
                    ],
                },
                series: [
                    {
                        name: `${this.$t('Stats.Revenue.total_revenue')}：${this.charData.pieChart.totalRevenue}`,
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        normal: {
                            show: true,
                            position: 'outside',
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: '12',
                                fontWeight: 'normal',
                            },
                        },
                        data: [
                            {value: this.charData.pieChart.mshpRevenue, name: this.$t('Stats.Card.member')},
                            {value: this.charData.pieChart.privCoachRevenue, name: this.$t('Stats.Card.personal')},
                            {value: this.charData.pieChart.lockerRevenue, name: this.$t('Stats.Card.locker')},
                            {value: this.charData.pieChart.czCardRevenue, name: this.$t('Stats.Card.value_card')},
                            {value: this.charData.pieChart.prepayRevenue, name: this.$t('Sell.title5')},
                            {value: this.charData.pieChart.depositRevenue, name: this.$t('Stats.Card.charge')},
                            {value: this.charData.pieChart.otherRevenue, name: this.$t('Stats.Revenue.total_stop')},
                        ],
                    },
                ],
            };
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="scss">
.revenue-daily {
    .el-select {
        margin-right: 0.5rem;
    }
    .el-button {
        margin-left: 0.5rem;
    }
}
.daily-header-right {
    line-height: 32px;
    font-size: 12px;
    float: right;
}
.daily-chart-content {
    margin: 25px 0;
}
.daily-chart-left {
    overflow: auto;
    border: 1px solid #f0f0f0;
    padding: 20px 10px;
    margin-right: 20px;
    width: 61%;
}
.daily-chart-right {
    overflow: auto;
    border: 1px solid #f0f0f0;
    padding: 20px 10px;
    width: 39%;
}
.flow-date-btn {
    margin-bottom: 25px;
}
.table-cart-small {
    div {
        font-size: 12px;
    }
}
</style>
